module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.authenticated) ? _c('v-navigation-drawer', {
    attrs: {
      "enable-resize-watcher": "",
      "clipped": "",
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('nav-menu')], 1) : _vm._e(), _vm._v(" "), _c('tool-bar', {
    attrs: {
      "drawer": _vm.drawer
    },
    on: {
      "toggleDrawer": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('feedback-message'), _vm._v(" "), _c('page-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c974bdb","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app.vue
// module id = M27c
// module chunks = 1